import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { api, setToken, apiError } from "@/lib/api";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) return setError("أدخل البريد الإلكتروني وكلمة المرور");
    try {
      setLoading(true);
      const { data } = await api.post("/admin/login", { email, password });
      setToken(data.token);
      onLogin();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-forest-950 px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-[2rem] border border-gold/20 bg-forest-900 p-9 shadow-2xl">
        <div className="flex flex-col items-center text-center">
          <img src="/logo.jpg" alt="شعار حلاق - 7ala9" className="h-16 w-auto rounded-xl" />
          <h1 className="mt-5 font-head text-xl font-extrabold text-cream">لوحة تحكم حلاق</h1>
          <p className="mt-1 text-xs text-cream/50">الدخول مخصص للمشرفين فقط</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            type="email"
            dir="ltr"
            data-testid="admin-login-email"
            placeholder="admin@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-cream/15 bg-forest-950 px-4 py-3 text-left text-sm text-cream transition focus:border-gold focus:outline-none"
          />
          <input
            type="password"
            dir="ltr"
            data-testid="admin-login-password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl border border-cream/15 bg-forest-950 px-4 py-3 text-left text-sm text-cream transition focus:border-gold focus:outline-none"
          />
          {error && (
            <p className="rounded-xl bg-brick/15 px-4 py-3 text-center text-sm font-medium text-red-300" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 font-head font-extrabold text-forest-950 transition hover:bg-gold-light disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            تسجيل الدخول
          </button>
        </form>
      </div>
    </div>
  );
}
